/**
 * Utilidades para detectar el navegador y sus capacidades
 */

export interface BrowserInfo {
  isSafariIOS: boolean;
  isChromeAndroid: boolean;
  isFirefox: boolean;
  isSafari: boolean;
  isChrome: boolean;
  supportsMediaRecorder: boolean;
  supportsWebAudio: boolean;
  supportsServiceWorker: boolean;
  supportsIndexedDB: boolean;
}

export function detectBrowser(): BrowserInfo {
  const userAgent = navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(userAgent);
  const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent);
  const isChrome = /chrome/.test(userAgent) && !/edg/.test(userAgent);
  const isFirefox = /firefox/.test(userAgent);
  const isAndroid = /android/.test(userAgent);

  return {
    isSafariIOS: isIOS && isSafari,
    isChromeAndroid: isAndroid && isChrome,
    isFirefox,
    isSafari: isSafari && !isIOS,
    isChrome: isChrome && !isAndroid,
    supportsMediaRecorder: typeof MediaRecorder !== 'undefined',
    supportsWebAudio: typeof AudioContext !== 'undefined' || typeof (window as any).webkitAudioContext !== 'undefined',
    supportsServiceWorker: 'serviceWorker' in navigator,
    supportsIndexedDB: 'indexedDB' in window,
  };
}

export function isMobileDevice(): boolean {
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    navigator.userAgent.toLowerCase()
  );
}

export function getScreenOrientation(): 'portrait' | 'landscape' {
  if (window.innerHeight > window.innerWidth) {
    return 'portrait';
  }
  return 'landscape';
}


